import React from 'react';
import UserApi from '../../firebase/UserApi';
import { withFirebase } from '../FirebaseUserContext';
import AuthUserContext from './context';


const withAuthentication = Component => {
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);
            this.lastCommitted = undefined;
            this.state = {
                authUser: undefined,
                signedIn: false,
                claims: {},
            }
        }

        async componentDidMount() {
            this.authStateListener = this.props.firebase.auth.onAuthStateChanged(
                async authUser => {
                    authUser = authUser ? { ...authUser, claims: await UserApi.getClaims() } : { claims: {} };
                    this.setState({ signedIn: !!authUser, authUser: authUser ? authUser : null, claims: authUser.claims });
                    if (authUser) {
                        this.claimsListener = UserApi.claimSnapshotListener(authUser, (claims, impersonate) => {
                            this.setState({authUser: {...authUser, claims: claims, impersonate}, claims: claims})
                        });
                    }
                }
            );
        }

        componentWillUnmount() {
            this.authStateListener();
            if (this.claimsListener) this.claimsListener();
        }

        render() {

            console.log(this.state.authUser)
            return (
                <AuthUserContext.Provider value={{ authUser: this.state.authUser, isSignedIn: this.state.signedIn }}>
                    <Component {...this.props} />
                </AuthUserContext.Provider>
            )
        }
    }

    return withFirebase(WithAuthentication);
}

export default withAuthentication;
